import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PreloadLink = ({ to, children, className, prefetch = true, ...props }) => {
  const navigate = useNavigate();

  const prefetchComponent = async () => {
    try {
      // Handle different route patterns
      const componentPath = to === '/' ? './pages/LandingPage' :
        to.startsWith('/services/') ? `./pages/services/${to.split('/').pop()}Page` :
        `./pages/${to.split('/')[1].charAt(0).toUpperCase() + to.split('/')[1].slice(1)}Page`;

      // Dynamically import the component
      await import(`../pages/${componentPath}`).catch(() => {});
    } catch (error) {
      // Silently handle import errors
      console.debug('Prefetch error:', error);
    }
  };

  const handleMouseEnter = () => {
    if (prefetch) {
      prefetchComponent();
    }
  };

  return (
    <Link
      to={to}
      className={className}
      onMouseEnter={handleMouseEnter}
      {...props}
    >
      {children}
    </Link>
  );
};

export default PreloadLink;